
import { Component, Prop } from 'nuxt-property-decorator'
import { FSXABaseComponent } from 'fsxa-pattern-library'
import { scrollToSection } from '../../shared/general/services/AnchorLinkService'

@Component({
  name: 'PageContent',
})
export default class PageContent extends FSXABaseComponent {
  // Base height of header. It was hard coded before and because Nuxt2 will be shut down anyways, I kept it
  @Prop({ default: 88 }) headerHeight! : number

  private lastScroll : number = 0

  mounted () {
    this.$nextTick(() => {
      const headerWrapper = document.querySelector('.header-wrapper')
      this.animateHeaderOnScroll(headerWrapper as HTMLElement)

      const { hash } = window.location
      if (!hash) return

      scrollToSection(hash)
    })
  }

  private animateHeaderOnScroll (headerWrapper : HTMLElement | null) : void {
    if (!headerWrapper) return
    window.addEventListener('scroll', () => this.scrollListener(headerWrapper))
  }

  private scrollListener (headerWrapper : HTMLElement) : void {
    const currentScroll = window.scrollY

    if (this.isSafariBrowser()) {
      // Workaround for Safari bug when scrolling to the top
      if ((window.innerHeight + window.scrollY) < window.innerHeight) {
        return
      }

      // Workaround for Safari bug when scrolling to the bottom
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
        return
      }
    }

    const header = headerWrapper.querySelector('#header')
    if (!header) return

    if (!this.isDarkLayerVisible && currentScroll > this.lastScroll && currentScroll > this.headerHeight) {
      headerWrapper.style.transform = `translateY(-${header.clientHeight}px)`
    }

    if (currentScroll < this.lastScroll) {
      headerWrapper.style.transform = 'translateY(0px)'
    }

    this.lastScroll = currentScroll
  }

  private isSafariBrowser () : boolean {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  }

  private get isNavigationOpen () : boolean {
    return this.$store.state.Page.isNavigationOpen
  }

  private get isDarkLayerVisible () : boolean {
    return this.$store.state.PageHeader.isDarkLayerVisible
  }
}
